export const HEADER_TITLE = 'Loan Details';
